<template>
    <div class="corporateCultureBox">
        <aboutBannerVue tabIndex="6"></aboutBannerVue>
        <div :class="isMobile?'teamBoxs':'teamBox'">
            <p class="font20 fontw">专家团队</p>
            <el-carousel indicator-position="outside" v-if="teamList.length!=0" :autoplay="true" :interval="5000" @change="changeSwiper" arrow="never" :height="isMobile?'360px':'780px'">
                <el-carousel-item v-for="(item,index) in length" :key="index">
                    <div class="team">
                        <div :class="isMobile?'teamItem':'teamList'" v-for="(item,index) in teamList" :key="index">
                            <img class="teamImg" :src="item.picture" alt="">
                            <p class="fontw name">{{item.title}}</p>
                            <div class="tag" v-if="item.tag">
                                <span>{{item.tag}}</span>
                            </div>
                            <el-popover  placement="top" title="专家优势" width="200" trigger="hover">
                                <div class="miaoshu" v-html="'<p class=\'fontw mt10 mb10\'>执（职）业资格</p>'+item.power+'<p class=\'fontw mt10 mb10\'>擅长领域--</p>'+item.area"></div>
                                <p class="miaoshu overh2" slot="reference" v-html="item.power?item.power+'、'+item.area:''"></p>
                            </el-popover>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
            <div v-if="teamList.length==0">
                <el-empty description="暂无数据"></el-empty>
            </div>
        </div>
    </div>
</template>

<script>
    import aboutBannerVue from '@/components/aboutBanner'
    import teamList from '@/js/person.js'
	export default {
		name:'ExpertTeam',
        components:{aboutBannerVue},
        data() {
            return {
                teamList:[],
                length:1,
            }
        },
        mounted(){
            this.getteam()
        },
        methods:{
            // 获取专家团队列表
            getteam(){
                this.teamList = teamList
                if(this.isMobile){
                    this.length =Math.ceil(teamList.length / 2)
                }else{
                    this.length =Math.ceil(teamList.length / 8)
                }
            },

            //修改轮播图索引
            changeSwiper(e){
                this.teamList= this.isMobile?teamList.slice(2*e,2*e+2):teamList.slice(8*e,8*e+8)
            }
        }
	}
</script>

<style scoped>
    .teamBox{
        width: 1200px;
        margin: 0 auto;
        margin-top: 42px;
        padding-bottom: 20px;
    }
    .teamBoxs{
        width: calc(100% - 20px);
        margin: 0 auto;
        margin-top: 20px;
        padding-bottom: 20px;
    }
    .team{
        display: flex;
        justify-content: flex-start;
        flex-flow: wrap;
        margin-top: 36px;
        margin-left: 2px;
    }
    .teamList{
        width: 284px;
        height: 350px;
        box-shadow: 0px 0px 5px 2px rgba(45,45,45,0.06);
        border-radius: 5px;
        margin-right: 19px;
        margin-bottom: 20px;
        padding: 25px 16px;
    }
    .teamList:nth-child(4n){
        margin-right:0;
    }
    .teamImg{
        display: block;
        width: 115px;
        height: 150px;
        border-radius: 5px;
        margin: 0 auto;
    }
    .teamList .name,.teamItem .name{
        text-align: center;
        margin-top: 15px;
    }
    .teamList:hover .name{
        color: #247CD6;
    }
    .teamItem{
        width: 48%;
        box-shadow: 0px 0px 5px 2px rgba(45,45,45,0.06);
        border-radius: 5px;
        margin-bottom: 20px;
        padding: 10px;
        margin-right: 4%;
    }
    .teamItem:nth-child(2n){
        margin-right: 0;
    }
    .tag{
        margin-top: 15px;
    }
    .tag span{
        display: block;
        width: 106px;
        height: 24px;
        margin: 0 auto;
        text-align: center;
        line-height: 24px;
        background-color: #DBF0FF;
        color: #157FCC;
        font-size: 14px;
        border-radius: 3px;
    }
    .miaoshu{
        margin-top: 20px;
        color: #666;
        line-height: 24px;
        font-size: 14px;
    }
</style>
<style>
    .teamBox .el-carousel__container,.teamBoxs .el-carousel__container{
        height: 780px;
        max-height: 780px;
    }
    .teamBox .el-carousel__button,.teamBoxs .el-carousel__button{
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }
    .teamBox .el-carousel__indicators--outside button,.teamBoxs .el-carousel__indicators--outside button{
        background-color: #D5D5D5;
    }
    .teamBox .el-carousel__indicator.is-active button,.teamBoxs .el-carousel__indicator.is-active button{
        background-color: #247CD6;
    }
</style>
